<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="subscriptionAfiliate"
    data-dismiss="modal"
    tabindex="-2"
    role="dialog"
    aria-labelledby="subscriptionAfiliate"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content modal-subscription">
        <div class="modal-header">
          <button
            period="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div class="modal-body pt-2">
          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="col-12 text-left">
                  <h1 class="plan-subheader">Resumen de compra</h1>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div class="plan-remark">
                    Plan {{ selectedPlan.subscription.name }}
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <p class="plan-description mb-0">
                    {{ selectedPlan.subscription.description }}
                  </p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div>
                    <span class="plan-primary">Forma de cobro:</span>
                    <span
                      class="ml-1 plan-secondary"
                      v-if="selectedPlan.period == 1"
                      >mensual</span
                    >
                    <span class="ml-1 plan-secondary" v-else>anual</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div>
                    <span class="plan-primary">Fecha de inicio del plan:</span>
                    <span class="ml-1 plan-secondary">{{ dateStart }}</span>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-9">
                  <div class="container-message-plan">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-exclamation-circle"></i>
                      <div class="ml-2 title">
                        Hoy inicia tu prueba gratuita de 30 días
                      </div>
                    </div>
                    <p class="mb-0 subtitle">
                      No se te cobrará hasta la fecha de tu primer pago y puedes
                      cancelar la prueba cuando quieras*
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <div class="pb-2">
                    <span class="plan-primary ">Primer pago:</span>
                    <span
                      class="plan-secondary ml-1"
                      v-if="selectedPlan.period == 2"
                      >{{ dateEndMonth }}</span
                    >
                    <span class="plan-secondary ml-1" v-else>{{
                      dateEndMonth
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <div
                    class="pb-2"
                    style="border-bottom: solid 1px lightgray; width: fit-content;"
                  >
                    <span class="plan-primary light">Próximo pago:</span>
                    <span
                      class="plan-primary light ml-1"
                      v-if="selectedPlan.period == 2"
                      >{{ dateEndYear }}</span
                    >
                    <span class="plan-primary light ml-1" v-else>{{
                      dateEndTrialMonth
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12">
                  <div class="d-flex align-items-center">
                    <span class="plan-primary lg">Total:</span>
                    <span class="plan-primary lg ml-1"
                      >{{ this.calculateTotalPlan | currency }}
                      {{ selectedPlan.subscription.prices[0].currency }}</span
                    >
                    <div
                      v-if="
                        this.couponData.is_valid_coupon == true &&
                          this.couponData.coupon_data != null
                      "
                    >
                      <span
                        class="plan-primary light ml-1"
                        v-if="this.couponData.coupon_data.duration == 'once'"
                        >Uso único</span
                      >
                      <span
                        class="plan-primary light ml-1"
                        v-if="
                          this.couponData.coupon_data.duration == 'repeating'
                        "
                        >Durante
                        {{ this.couponData.coupon_data.duration_in_months }}
                        meses</span
                      >
                      <span
                        class="plan-primary light ml-1"
                        v-if="this.couponData.coupon_data.duration == 'forever'"
                        >Permanente</span
                      >
                    </div>
                  </div>
                  <span
                    class="plan-primary light"
                    v-if="selectedPlan.period == 1"
                    >Suscripción mensual</span
                  >
                  <span class="plan-primary light" v-else
                    >Suscripción anual</span
                  >
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <p class="mb-0 footer-plan">
                    *Deberás cancelar antes de que terminen los 30 días
                    naturales de tu prueba. Una vez concluido el periodo
                    gratuito, de no haber cancelado el plan, se realizará un
                    cobro automático a la tarjeta proporcionada.
                  </p>
                </div>
              </div>
            </div>

            <!-- INVOICING -->
            <div
              class="col-6"
              style="border-left: solid 1px lightgray;"
              v-show="!showPaymentDetails"
            >
              <div class="row">
                <div class="col-12">
                  <div class="plan-primary lg">Facturación</div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-12">
                  <div class="d-flex align-items-center mb-3 mr-2">
                    <label class="switch m-0 flex-shrink-0">
                      <input type="checkbox" v-model="useAutoFacture" />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-2">Activar facturación automática</span>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12 text-left">
                  <div class="plan-primary lg">Datos de facturación</div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="input-no-label form-control"
                      :disabled="useAutoFacture == false"
                      :class="{
                        'is-invalid': $v.facturacionData.legal_name.$error,
                      }"
                      v-model="facturacionData.legal_name"
                      placeholder="Razón social"
                    />
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="input-no-label form-control"
                      :disabled="useAutoFacture == false"
                      :class="{
                        'is-invalid': $v.facturacionData.tax_id.$error,
                      }"
                      v-model="facturacionData.tax_id"
                      placeholder="RFC"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- REGIMEN FISCAL -->
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="form-group">
                    <select
                      class="input-append custom-select"
                      style="border-radius:12px;padding:12px 15px;height:auto;"
                      :disabled="useAutoFacture == false"
                      :class="{
                        'is-invalid': $v.facturacionData.tax_regime.$error,
                      }"
                      v-model="facturacionData.tax_regime"
                    >
                      <option value="Persona Física">Persona Física</option>
                      <option value="Persona Moral">Persona Moral</option>
                    </select>
                  </div>
                </div>

                <!-- POSTAL CODE -->
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="input-no-label form-control"
                      :disabled="useAutoFacture == false"
                      :class="{
                        'is-invalid': $v.facturacionData.zipcode.$error,
                      }"
                      v-model="facturacionData.zipcode"
                      placeholder="Código postal"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- USO CDFI -->
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <div class="form-group">
                    <select
                      class="input-append custom-select"
                      style="border-radius:12px;padding:12px 15px;height:auto;"
                      :disabled="useAutoFacture == false"
                      :class="{
                        'is-invalid': $v.facturacionData.use_cfdi.$error,
                      }"
                      v-model="facturacionData.use_cfdi"
                    >
                      <option value="">Uso del CFDI</option>
                      <option
                        v-for="(cfdi, index) in cfdiOptions"
                        :key="index"
                        v-bind:value="cfdi.value"
                      >
                        {{ cfdi.label }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- EMAIL -->
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="form-group">
                    <input
                      type="email"
                      class="input-no-label form-control"
                      :disabled="useAutoFacture == false"
                      :class="{ 'is-invalid': $v.facturacionData.email.$error }"
                      v-model="facturacionData.email"
                      placeholder="Email de facturación"
                    />
                    <small
                      class="form-text text-danger"
                      v-show="!$v.facturacionData.email.email"
                      >Ingresa un email válido</small
                    >
                  </div>
                </div>
              </div>

              <div v-if="!facturacionData.same_address">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :disabled="useAutoFacture == false"
                        :class="{
                          'is-invalid': $v.facturacionData.telephone.$error,
                        }"
                        v-model="facturacionData.telephone"
                        placeholder="Teléfono"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <select
                        class="input-append custom-select"
                        style="border-radius:12px;padding:12px 15px;height:auto;"
                        :disabled="useAutoFacture == false"
                        :class="{
                          'is-invalid': $v.facturacionData.country_id.$error,
                        }"
                        v-model="facturacionData.country_id"
                      >
                        <option value="">Selecciona un país</option>
                        <option
                          v-for="(country, index) in countries"
                          :key="index"
                          v-bind:value="country.id"
                        >
                          {{ country.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :disabled="useAutoFacture == false"
                        :class="{
                          'is-invalid': $v.facturacionData.state.$error,
                        }"
                        v-model="facturacionData.state"
                        placeholder="Estado"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :disabled="useAutoFacture == false"
                        :class="{
                          'is-invalid': $v.facturacionData.city.$error,
                        }"
                        v-model="facturacionData.city"
                        placeholder="Ciudad"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :disabled="useAutoFacture == false"
                        :class="{
                          'is-invalid': $v.facturacionData.street.$error,
                        }"
                        v-model="facturacionData.street"
                        placeholder="Calle"
                      />
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                      <input
                        type="text"
                        class="input-no-label form-control"
                        :disabled="useAutoFacture == false"
                        :class="{
                          'is-invalid': $v.facturacionData.number_ext.$error,
                        }"
                        v-model="facturacionData.number_ext"
                        placeholder="Número exterior"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="em-check-cont">
                    <label class="container-check">
                      <input
                        class="form-check-input"
                        :disabled="useAutoFacture == false"
                        type="checkbox"
                        v-model="facturacionData.same_address"
                        checked="true"
                        @click="
                          facturacionData.same_address = !facturacionData.same_address
                        "
                      />
                      <span class="checkmark"></span>
                      <span
                        class="ml-2"
                        v-bind:class="{ 'text-muted': useAutoFacture == false }"
                        >Misma dirección en registro</span
                      >
                    </label>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-10 offset-1">
                  <button
                    type="button"
                    class="btn btn-save form-control text-center text-uppercase"
                    @click="validateFacturar()"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-6 text-left px-5 flex-column justify-content-center"
              :class="{ 'd-flex': showPaymentDetails }"
              style="border-left: solid 1px lightgray;"
              v-show="showPaymentDetails"
            >
              <div class="row mb-2" v-if="couponData.is_valid_coupon == true">
                <div class="col-12">
                  <div class="d-flex">
                    <span class="plan-secondary">¡Cupón válido!</span>
                    <span
                      class="plan-primary ml-1"
                      v-if="couponData.coupon_data.percent_off != null"
                      >{{ couponData.coupon_data.percent_off }}% de
                      descuento</span
                    >
                    <span
                      class="plan-primary ml-1"
                      v-if="couponData.coupon_data.amount_off != null"
                      >Descuento de ${{
                        couponData.coupon_data.amount_off / 100
                      }}
                      MXN</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="row mb-2"
                v-if="
                  couponData.is_valid_coupon == false &&
                    couponData.promotion_code == false
                "
              >
                <div class="col-12">
                  <div class="d-flex">
                    <span class="plan-error">El cupón no es válido</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group d-flex mb-0">
                    <input
                      type="text"
                      id="name"
                      class="input-no-label form-control"
                      placeholder="Cupón de descuento"
                      v-model="couponData.coupon_input"
                    />
                    <button
                      class="ml-2 btn btn-save form-control text-center text-uppercase"
                      @click="checkCoupon()"
                    >
                      Validar
                    </button>
                  </div>
                </div>
              </div>
              <hr style="margin: 1.5rem 0 1rem 0 !important;" />
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      id="name"
                      class="input-no-label form-control"
                      :class="{ 'is-invalid': $v.userData.name.$error }"
                      v-model="userData.name"
                      placeholder="Nombre"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <input
                      type="email"
                      id="email"
                      class="input-no-label form-control"
                      :class="{ 'is-invalid': $v.userData.email.$error }"
                      v-model="userData.email"
                      placeholder="Correo"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      id="phone"
                      class="input-no-label form-control"
                      :class="{ 'is-invalid': $v.userData.phone.$error }"
                      v-model="userData.phone"
                      placeholder="Teléfono"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div class="form-group">
                    <div id="card-element"></div>
                    <div
                      id="card-errors"
                      class="text-danger text-left"
                      style="font-size: 10px"
                      role="alert"
                    >
                      {{ errorMessage }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12">
                  <button
                    type="button"
                    :disabled="cardErrors"
                    class="btn btn-save form-control text-center text-uppercase"
                    @click="sendSubscribe()"
                  >
                    <span>Pagar {{ calculateTotalPlan | currency }} </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Definicion de variables de stripe */
var stripe;
if (process.env.NODE_ENV != "development") {
  stripe = window.Stripe(
    "pk_live_51HRMCLKkIGgB4LQza1KU154xMkB0jqbV96jsMyUoI51HnTtq91ObYI68bz574l7gK2WBnT4Jfhb8IgEOf6DTb1mt00aMFUSCFS"
  );
} else {
  stripe = window.Stripe(
    "pk_test_51HRMCLKkIGgB4LQz3NYkulIMvr0cnqvcimS7GYV8CgXS3bG7iQV5e6UkfJXWN5RyfQfWgAYvsS6Ayl3Z8POAUGA400NITo53lO"
  );
}

const elements = stripe.elements({
  fonts: [
    {
      // integrate your font into stripe
      cssSrc:
        "https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap",
    },
  ],
});

import filters from "@/mixins/filters";
import data from "@/mixins/data";
/* import api */
import plansService from "@/api/plans";
import moment from "moment";
import $ from "jquery";
import { validationMixin } from "vuelidate";
import { required, numeric, email, requiredIf } from "vuelidate/lib/validators";

export default {
  mixins: [filters, validationMixin, data],
  updated() {
    // Hide invoice information form when team country is not MX.
    if (this.company.team.country.code !== "MX") {
      this.showPaymentDetails = true;
    }
  },

  mounted() {
    // Hide invoice information form when team country is not MX.
    if (this.company.team.country.code !== "MX") {
      this.showPaymentDetails = true;
    }

    if (this.card != null) {
      this.card.unmount();
    }

    this.card = elements.create("card", {
      style: {
        base: {
          color: "#B3B3B3",
          fontFamily: "Open Sans", // set integrated font family
          fontSmoothing: "antialiased",
          fontSize: "15px",
          "::placeholder": {
            color: "#6c757d",
          },
        },
      },
    });
    this.card.mount("#card-element");
    this.card.addEventListener("change", (event) => {
      if (event.error) {
        this.errorMessage = event.error.message;
      } else {
        this.errorMessage = "";
      }
      if (event.complete == true && event.error == null) {
        this.cardErrors = false;
      } else {
        this.cardErrors = true;
      }
    });
    switch (this.selectedPlan.period) {
      /* Mensual */
      case 1:
        /* Plan Personal */
        if (this.selectedPlan.plan == 2) {
          this.planSelected = "individual_month";
        }

        if (this.selectedPlan.plan == 3) {
          this.planSelected = "team_month";
        }
        break;

      /* Anual */
      case 2:
        if (this.selectedPlan.plan == 2) {
          this.planSelected = "individual_year";
        }

        if (this.selectedPlan.plan == 3) {
          this.planSelected = "team_year";
        }
        break;
    }
    var that = this;
    $("#subscriptionAfiliate").on("hidden.bs.modal", function() {
      that.showPaymentDetails = false;
    });
  },

  beforeDestroy() {
    if (this.card != null) {
      this.card.destroy();
    }
    $(".modal-backdrop").remove();
  },
  data() {
    return {
      country_id: 1,
      country_name: "Selecciona un país",
      showPaymentDetails: false,
      useAutoFacture: false,
      facturacionData: {
        legal_name: null,
        tax_id: null,
        tax_regime: "Persona Física",
        email: null,
        use_cfdi: "",
        same_address: true,
        telephone: null,
        country_id: "",
        state: null,
        city: null,
        street: null,
        number_ext: null,
        zipcode: null,
      },
      card: null,
      errorMessage: "",
      cardErrors: true,
      dateStart: moment().format("ll"),
      dateEndYear: moment()
        .add(1, "year")
        .format("ll"),
      dateEndMonth: moment()
        .add(1, "month")
        .format("ll"),
      dateEndTrialMonth: moment()
        .add(2, "month")
        .format("ll"),
      planSelected: "",
      userData: {
        name: "",
        email: "",
        phone: "",
      },
      couponData: {
        coupon_input: "",
        promotion_code: null,
        is_valid_coupon: false,
        coupon_data: null,
      },
    };
  },
  computed: {
    calculateTotalPlan() {
      if (this.couponData.is_valid_coupon == true) {
        return this.couponData.coupon_data.amount_to_pay / 100;
      } else {
        if (this.selectedPlan.period == 1) {
          var itemM = this.selectedPlan.subscription.prices
            .filter(function(itemM) {
              return itemM.recurring == "month";
            })
            .pop();
          return itemM.price;
        } else {
          var itemY = this.selectedPlan.subscription.prices
            .filter(function(itemY) {
              return itemY.recurring == "year";
            })
            .pop();
          return itemY.price;
        }
      }
    },
  },
  props: {
    selectedPlan: {
      required: true,
    },
    countries: {
      required: true,
      type: Array,
    },
  },
  methods: {
    selectCountry(countryId, countryName) {
      this.country_id = countryId;
      this.country_name = countryName;
    },
    validateFacturar() {
      if (this.useAutoFacture == false) {
        this.showPaymentDetails = true;
      } else {
        this.$v.$touch();
        if (this.$v.facturacionData.$invalid) {
          this.$store.dispatch("showMessage", {
            action: "error",
            message: "Llena todos los campos requeridos",
          });
        } else {
          this.$store.dispatch("showLoader", { show: true });
          let dataToSend = { ...this.facturacionData };
          dataToSend.same_address = dataToSend.same_address == true ? "1" : "0";
          plansService
            .saveFactureData(dataToSend)
            .then(() => {
              this.$store.dispatch("showLoader", { show: false });
              this.$store.dispatch("showMessage", {
                action: "success",
                message: "Datos guardados correctamente",
              });
              this.showPaymentDetails = true;
            })
            .catch(() => {
              this.$store.dispatch("showLoader", { show: false });
            });
        }
      }
    },
    createCustomer() {
      return new Promise((resolve, reject) => {
        plansService
          .createCustomer()
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createToken() {
      return new Promise((resolve, reject) => {
        let metaData = {
          name: this.userData.name,
          address_line1: this.userData.phone,
          address_country: "MX",
          email: this.userData.email,
        };
        stripe
          .createToken(this.card, metaData)
          .then((result) => {
            resolve(result.token.id);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addPaymentMethod(token) {
      let formatedToken = {
        token_card: token,
      };
      return new Promise((resolve, reject) => {
        plansService
          .addPaymentMethod(formatedToken)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    sendSubscribe() {
      this.$v.$touch();
      if (this.$v.userData.$invalid) {
        this.$store.dispatch("showMessage", {
          action: "error",
          message: "Llena todos los campos requeridos",
        });
      } else {
        this.$store.dispatch("showLoader", { show: true });
        this.createCustomer()
          .then(() => {
            this.createToken()
              .then((token) => {
                this.addPaymentMethod(token).then(() => {
                  let data;
                  if (
                    this.couponData.promotion_code != null &&
                    this.couponData.promotion_code != false
                  ) {
                    data = {
                      plan: this.planSelected,
                      promotion_id: this.couponData.promotion_code,
                    };
                  } else {
                    data = {
                      plan: this.planSelected,
                    };
                  }

                  plansService
                    .subscribePlan(data)
                    .then(() => {
                      this.$store.dispatch("client/setData").then(() => {
                        this.$store
                          .dispatch("client/updateConfiguration")
                          .then(() => {
                            $(".modal-backdrop").remove();
                            $("#subscriptionAfiliate").modal("hide");
                            this.$store.dispatch("showLoader", { show: false });
                            setTimeout(() => {
                              window.location.reload();
                            }, 3000);
                          });
                      });
                    })
                    .catch(() => {
                      this.$store.dispatch("showLoader", { show: true });
                    });
                });
              })
              .catch(() => {
                this.$store.dispatch("showLoader", { show: true });
              });
          })
          .catch(() => {
            this.$store.dispatch("showLoader", { show: true });
          });
      }
    },

    checkCoupon() {
      this.$store.dispatch("showLoader", { show: true });
      let data = {
        plan: this.planSelected,
        promotion_code: this.couponData.coupon_input,
      };
      plansService
        .getCouponInfo(data)
        .then((response) => {
          if (response.data.data.discount_apply == true) {
            this.couponData.coupon_data = response.data.data;
            (this.couponData.promotion_code = response.data.data.promotion_id),
              (this.couponData.is_valid_coupon = true);
          } else {
            this.couponData.coupon_data = null;
            (this.couponData.promotion_code = false),
              (this.couponData.is_valid_coupon = false);
          }

          this.$store.dispatch("showLoader", { show: false });
        })
        .catch(() => {
          this.couponData.coupon_data = null;
          (this.couponData.promotion_code = false),
            (this.couponData.is_valid_coupon = false);
          this.$store.dispatch("showLoader", { show: false });
        });
    },
  },

  validations: {
    userData: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        numeric,
      },
    },
    facturacionData: {
      legal_name: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      tax_id: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      tax_regime: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      zipcode: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      email: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
        email,
      },
      use_cfdi: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      same_address: {
        required: requiredIf(function() {
          return this.useAutoFacture == true;
        }),
      },
      telephone: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      country_id: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      state: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      city: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      street: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
      number_ext: {
        required: requiredIf(function() {
          return this.facturacionData.same_address == false;
        }),
      },
    },
  },
};
</script>
